import { MijnRoute } from '../mijn-navigatie.model';

export const ZAKELIJK_EXTRA_AFLOSSEN: MijnRoute = {
    path: 'zakelijk-extra-aflossen',
    navigationEvent: 'toZakelijkExtraAflossen',
    regex: /^\/zakelijk-extra-aflossen$/,
    webcomponent: 'mijn-zakelijk-extra-aflossen-webcomponent'
};
